var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 30,
        width: 580,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", { attrs: { height: "22", width: "200", y: "4.5", x: "4.5" } }),
      _vm._v(" "),
      _c("ellipse", {
        attrs: { ry: "9.5", rx: "10", cy: "15.5", cx: "564.5" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }